import styled from "styled-components";

import { FlexColumn } from "@similarweb/ui-components";

export const StyledSectionContainer = styled(FlexColumn)`
    flex: 1;
    min-height: 0;
    height: 100%;
`;
